<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h3>KIBANA(ElasticSearch)</h3>
    <ul>
      <li><a href="https://kibana.lidy.synology.me/" target="_blank" rel="noopener">Kibana</a></li>
      <li><label>TEST USER : </label><span>kibana_user / kibana</span></li>
    </ul>
    <h3>Redis</h3>
    <ul>
      <li><a href="https://www.lidy.synology.me/redis/swagger-ui/index.html" target="_blank" rel="noopener">Redis</a></li>
    </ul>
    <h3>Subtitle Factory Server</h3>
    <ul>
      <li><a href="https://www.lidy.synology.me/subfacserver/swagger-ui/index.html" target="_blank" rel="noopener">SubFac Server</a></li>
    </ul>
    <h3>Subtitle Factory Front</h3>
    <ul>
      <li><a href="https://subfac.lidy.synology.me/" target="_blank" rel="noopener">SubFac Front</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
